module.exports = __webpack_public_path__ + "fonts/NotoSans-Regular.e49f7cc.ttf";